export enum LoanItemStatus {
  NotRequired = 'NotRequired',
  NotComplete = 'NotComplete',
  Complete = 'Complete',
  Warning = 'Warning',
  Error = 'Error',
}

export enum LoanItemStatusIconType {
  None = '',
  Circle = 'fa fa-circle',
  EmptyCircle = 'pi pi-circle',
  Square = 'fa fa-square',
  Diamond = 'fa fa-square rotate-45',
  UnLock = 'fa fa-unlock-keyhole',
  Lock = 'fa fa-lock',
}
